document.querySelectorAll('.column_with_icon_text.group-block').forEach((column) => {
  column.addEventListener('click', () => {
    const iconBlock = column.querySelector('.icon-block:has(.column_icon_second)');
    if (!iconBlock) return;
    iconBlock.classList.toggle('checked');
  });
});


document.addEventListener('DOMContentLoaded', function () {
  
  const productMetafieldDesc = document.querySelectorAll('.accordion accordion-custom details.details .details-content');
  if (productMetafieldDesc.length > 0) {
    productMetafieldDesc.forEach(el => {
      if(el.textContent.trim() === '') {
        if(el.closest('accordion-custom')) el.closest('accordion-custom').style.setProperty('display', 'none', 'important');
      }
    })
  }




  // ------------------------------  slider js ------------------------------

  if (window.innerWidth > 749) return;

  
  const slider = document.querySelector('.icons-text-with__slider');
  if (!slider) return;

  const track = slider.querySelector('.group-block-content');
  if (!track) return;

  const slides = track.querySelectorAll('.icon-text__slides.group-block');
  if (!slides.length) return;

  const OFFSET_INDEX = 1; 

  let index = 0;
  let startX = 0;
  let isDragging = false;
  let prevTranslate = 0;
  let currentTranslate = 0;

  function slideWidth() {
    return slider.getBoundingClientRect().width;
  }

  /* ---------- Dots ---------- */
  const dotsWrap = document.createElement('div');
  dotsWrap.className = 'icons-text-slider-dots';

  slides.forEach((_, i) => {
    const dot = document.createElement('span');
    dot.className = 'icons-text-slider-dot';
    if (i === 0) dot.classList.add('active');

    dot.addEventListener('click', () => {
      index = i;
      updatePosition();
    });

    dotsWrap.appendChild(dot);
  });

  slider.after(dotsWrap);
  const dots = dotsWrap.children;

  /* ---------- Position Logic ---------- */
  function updatePosition(animate = true) {
    currentTranslate = (OFFSET_INDEX - index) * slideWidth();
    prevTranslate = currentTranslate;

    track.style.transition = animate ? 'transform 0.3s ease' : 'none';
    track.style.transform = `translateX(${currentTranslate}px)`;

    [...dots].forEach(d => d.classList.remove('active'));
    dots[index].classList.add('active');
  }

  /* ✅ INITIAL STATE → translateX(+365.6px) */
  updatePosition(false);

  /* ---------- Drag ---------- */
  function getX(e) {
    return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
  }

  function dragStart(e) {
    if (window.innerWidth > 749) return;
    isDragging = true;
    startX = getX(e);
    slider.classList.add('grabbing');
    track.style.transition = 'none';
  }

  function dragMove(e) {
    if (!isDragging) return;
    const diff = getX(e) - startX;
    currentTranslate = prevTranslate + diff;
    track.style.transform = `translateX(${currentTranslate}px)`;
  }

  function dragEnd() {
    if (!isDragging) return;
    isDragging = false;
    slider.classList.remove('grabbing');

    const movedBy = currentTranslate - prevTranslate;

    if (movedBy < -80) {
      index = (index + 1) % slides.length;
    } else if (movedBy > 80) {
      index = (index - 1 + slides.length) % slides.length;
    }

    updatePosition();
  }

  /* ---------- Events ---------- */
  track.addEventListener('mousedown', dragStart);
  track.addEventListener('mousemove', dragMove);
  track.addEventListener('mouseup', dragEnd);
  track.addEventListener('mouseleave', dragEnd);

  track.addEventListener('touchstart', dragStart, { passive: true });
  track.addEventListener('touchmove', dragMove, { passive: true });
  track.addEventListener('touchend', dragEnd);

  window.addEventListener('resize', () => updatePosition(false));

  // ------------------------------  slider js ------------------------------
  
});

// appstle subscriptions 

// (function () {

//   function convertSelect() {
//     const select = document.querySelector('#appstle_selling_plan0');

//     // If not found OR already converted → stop
//     if (!select || select.dataset.converted) return;

//     select.dataset.converted = "true";

//     const wrapper = document.createElement("div");
//     wrapper.className = "custom-plan-wrapper";

//     Array.from(select.options).forEach((option, index) => {

//       const box = document.createElement("div");
//       box.className = "custom-plan-box";
//       box.dataset.value = option.value;
//       box.innerHTML = `<strong>${option.text}</strong>`;

//       if (index === select.selectedIndex) {
//         box.classList.add("active");
//       }

//       box.addEventListener("click", function () {

//         wrapper.querySelectorAll(".custom-plan-box")
//           .forEach(b => b.classList.remove("active"));

//         this.classList.add("active");

//         select.value = this.dataset.value;
//         select.dispatchEvent(new Event("change", { bubbles: true }));
//       });

//       wrapper.appendChild(box);
//     });

//     select.parentNode.appendChild(wrapper);
//   }

//   // Observe DOM changes (for Appstle dynamic load)
//   const observer = new MutationObserver(function () {
//     convertSelect();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

// })();


// second js 

(function () {

  // #appstle_selling_plan0 can only exist on product templates — don't run a
  // body-wide MutationObserver on every other page of the site.
  if (!document.body.classList.contains('itg-template-product')) return;

  function convertSelect() {
    const select = document.querySelector('#appstle_selling_plan0');

    // Stop if not found OR already converted
    if (!select || select.dataset.converted) return;

    select.dataset.converted = "true";

    const wrapper = document.createElement("div");
    wrapper.className = "custom-plan-wrapper";

    Array.from(select.options).forEach((option, index) => {

      const box = document.createElement("div");
      box.className = "custom-plan-box";
      box.dataset.value = option.value;

      // -------- SPLIT "Save XX%" TEXT --------
      const saveMatch = option.text.match(/Save\s*\d+%/i);

      let titleText = option.text;
      let saveText = "";

      if (saveMatch) {
        saveText = saveMatch[0];
        titleText = option.text.replace(saveText, "").trim();
      }

      // Create HTML structure
      box.innerHTML = `
        <p>${titleText}</p>
        ${saveText ? `<span class="save-badge">${saveText}</span>` : ""}
      `;

      // Active state
      if (index === select.selectedIndex) {
        box.classList.add("active");
      }

      // Click event
      box.addEventListener("click", function () {

        wrapper.querySelectorAll(".custom-plan-box")
          .forEach(b => b.classList.remove("active"));

        this.classList.add("active");

        select.value = this.dataset.value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
      });

      wrapper.appendChild(box);
    });

    select.parentNode.appendChild(wrapper);
  }

  // -------- OBSERVE APPSTLE DYNAMIC LOAD --------
  const observer = new MutationObserver(function () {
    convertSelect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

// tidio chat open 

document.querySelector('a[href="#tidio-chat"]')?.addEventListener('click', function(e) {
  e.preventDefault();
  
  if (window.tidioChatApi) {
    window.tidioChatApi.open();
  } else {
    document.addEventListener('tidioChat-ready', function() {
      window.tidioChatApi.open();
    }, { once: true });
  }
});


document.addEventListener("DOMContentLoaded", () => {
  // Hero slide videos load and autoplay straight from their <source src>.
  // The poster <img class="slide__video-poster"> sits over the video (z-index 1)
  // so the LCP image paints first; fade it out once the video renders frames.
  document.querySelectorAll("video.slide__video").forEach((videoEl) => {
    const container = videoEl.closest(".slide__image-container");
    const poster = container && container.querySelector(".slide__video-poster");
    if (!poster) return;
    const hidePoster = () => poster.classList.add("is-hidden");
    if (!videoEl.paused && videoEl.readyState >= 3) {
      hidePoster();
    } else {
      videoEl.addEventListener("playing", hidePoster, { once: true });
    }
  });
});